/**
 * @generated SignedSource<<a5e688405391f2888a7bed5f56eccb0e>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Query } from 'relay-runtime';
export type useOffersQuery$variables = {
  fetchCashbacks: boolean;
  fetchDeals: boolean;
  promoRejectedTags?: ReadonlyArray<string> | null;
  promoTags?: ReadonlyArray<string> | null;
  rejectedTags?: ReadonlyArray<string> | null;
  requiredTags?: ReadonlyArray<string> | null;
};
export type useOffersQuery$data = {
  readonly cashbackPromos?: {
    readonly edges: ReadonlyArray<{
      readonly node: {
        readonly advertiser: {
          readonly name: string | null;
        } | null;
        readonly desktopImageUrl: string | null;
        readonly guid: string;
        readonly id: string;
        readonly imageUrl: string | null;
        readonly rewardLabel: string | null;
        readonly tags: ReadonlyArray<string>;
        readonly title: string;
      };
    }>;
  } | null;
  readonly cashbacks?: {
    readonly edges: ReadonlyArray<{
      readonly node: {
        readonly advertiser: {
          readonly imageUrl: string | null;
          readonly name: string | null;
        } | null;
        readonly categories: ReadonlyArray<{
          readonly name: string;
          readonly tag: string;
        }>;
        readonly description: string | null;
        readonly guid: string;
        readonly id: string;
        readonly paysReward: boolean;
        readonly rewardLabel: string | null;
        readonly tags: ReadonlyArray<string>;
        readonly title: string;
      };
    }>;
  } | null;
  readonly dealPromos?: {
    readonly edges: ReadonlyArray<{
      readonly node: {
        readonly advertiser: {
          readonly name: string | null;
        } | null;
        readonly desktopImageUrl: string | null;
        readonly guid: string;
        readonly id: string;
        readonly imageUrl: string | null;
        readonly rewardLabel: string | null;
        readonly tags: ReadonlyArray<string>;
        readonly title: string;
      };
    }>;
  } | null;
  readonly deals?: {
    readonly edges: ReadonlyArray<{
      readonly node: {
        readonly advertiser: {
          readonly imageUrl: string | null;
          readonly name: string | null;
        } | null;
        readonly categories: ReadonlyArray<{
          readonly name: string;
          readonly tag: string;
        }>;
        readonly description: string | null;
        readonly guid: string;
        readonly id: string;
        readonly paysReward: boolean;
        readonly rewardLabel: string | null;
        readonly tags: ReadonlyArray<string>;
        readonly title: string;
      };
    }>;
  } | null;
};
export type useOffersQuery = {
  response: useOffersQuery$data;
  variables: useOffersQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "fetchCashbacks"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "fetchDeals"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "promoRejectedTags"
},
v3 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "promoTags"
},
v4 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "rejectedTags"
},
v5 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "requiredTags"
},
v6 = [
  {
    "fields": [
      {
        "kind": "Variable",
        "name": "rejectedTags",
        "variableName": "rejectedTags"
      },
      {
        "kind": "Variable",
        "name": "requiredTags",
        "variableName": "requiredTags"
      }
    ],
    "kind": "ObjectValue",
    "name": "input"
  }
],
v7 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v8 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "guid",
  "storageKey": null
},
v9 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "title",
  "storageKey": null
},
v10 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "rewardLabel",
  "storageKey": null
},
v11 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
},
v12 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "imageUrl",
  "storageKey": null
},
v13 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "tags",
  "storageKey": null
},
v14 = {
  "alias": null,
  "args": null,
  "concreteType": "OfferEdge",
  "kind": "LinkedField",
  "name": "edges",
  "plural": true,
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "Offer",
      "kind": "LinkedField",
      "name": "node",
      "plural": false,
      "selections": [
        (v7/*: any*/),
        (v8/*: any*/),
        (v9/*: any*/),
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "description",
          "storageKey": null
        },
        (v10/*: any*/),
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "paysReward",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "Advertiser",
          "kind": "LinkedField",
          "name": "advertiser",
          "plural": false,
          "selections": [
            (v11/*: any*/),
            (v12/*: any*/)
          ],
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "Category",
          "kind": "LinkedField",
          "name": "categories",
          "plural": true,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "tag",
              "storageKey": null
            },
            (v11/*: any*/)
          ],
          "storageKey": null
        },
        (v13/*: any*/)
      ],
      "storageKey": null
    }
  ],
  "storageKey": null
},
v15 = [
  (v14/*: any*/)
],
v16 = [
  {
    "fields": [
      {
        "kind": "Variable",
        "name": "rejectedTags",
        "variableName": "promoRejectedTags"
      },
      {
        "kind": "Variable",
        "name": "requiredTags",
        "variableName": "promoTags"
      }
    ],
    "kind": "ObjectValue",
    "name": "input"
  }
],
v17 = {
  "alias": null,
  "args": null,
  "concreteType": "OfferEdge",
  "kind": "LinkedField",
  "name": "edges",
  "plural": true,
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "Offer",
      "kind": "LinkedField",
      "name": "node",
      "plural": false,
      "selections": [
        (v7/*: any*/),
        (v8/*: any*/),
        (v12/*: any*/),
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "desktopImageUrl",
          "storageKey": null
        },
        (v9/*: any*/),
        (v10/*: any*/),
        {
          "alias": null,
          "args": null,
          "concreteType": "Advertiser",
          "kind": "LinkedField",
          "name": "advertiser",
          "plural": false,
          "selections": [
            (v11/*: any*/)
          ],
          "storageKey": null
        },
        (v13/*: any*/)
      ],
      "storageKey": null
    }
  ],
  "storageKey": null
},
v18 = [
  (v17/*: any*/)
],
v19 = [
  (v14/*: any*/),
  (v7/*: any*/)
],
v20 = [
  (v17/*: any*/),
  (v7/*: any*/)
];
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/),
      (v3/*: any*/),
      (v4/*: any*/),
      (v5/*: any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "useOffersQuery",
    "selections": [
      {
        "condition": "fetchCashbacks",
        "kind": "Condition",
        "passingValue": true,
        "selections": [
          {
            "alias": null,
            "args": (v6/*: any*/),
            "concreteType": "OfferConnection",
            "kind": "LinkedField",
            "name": "cashbacks",
            "plural": false,
            "selections": (v15/*: any*/),
            "storageKey": null
          },
          {
            "alias": "cashbackPromos",
            "args": (v16/*: any*/),
            "concreteType": "OfferConnection",
            "kind": "LinkedField",
            "name": "cashbacks",
            "plural": false,
            "selections": (v18/*: any*/),
            "storageKey": null
          }
        ]
      },
      {
        "condition": "fetchDeals",
        "kind": "Condition",
        "passingValue": true,
        "selections": [
          {
            "alias": null,
            "args": (v6/*: any*/),
            "concreteType": "OfferConnection",
            "kind": "LinkedField",
            "name": "deals",
            "plural": false,
            "selections": (v15/*: any*/),
            "storageKey": null
          },
          {
            "alias": "dealPromos",
            "args": (v16/*: any*/),
            "concreteType": "OfferConnection",
            "kind": "LinkedField",
            "name": "deals",
            "plural": false,
            "selections": (v18/*: any*/),
            "storageKey": null
          }
        ]
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v5/*: any*/),
      (v4/*: any*/),
      (v3/*: any*/),
      (v2/*: any*/),
      (v0/*: any*/),
      (v1/*: any*/)
    ],
    "kind": "Operation",
    "name": "useOffersQuery",
    "selections": [
      {
        "condition": "fetchCashbacks",
        "kind": "Condition",
        "passingValue": true,
        "selections": [
          {
            "alias": null,
            "args": (v6/*: any*/),
            "concreteType": "OfferConnection",
            "kind": "LinkedField",
            "name": "cashbacks",
            "plural": false,
            "selections": (v19/*: any*/),
            "storageKey": null
          },
          {
            "alias": "cashbackPromos",
            "args": (v16/*: any*/),
            "concreteType": "OfferConnection",
            "kind": "LinkedField",
            "name": "cashbacks",
            "plural": false,
            "selections": (v20/*: any*/),
            "storageKey": null
          }
        ]
      },
      {
        "condition": "fetchDeals",
        "kind": "Condition",
        "passingValue": true,
        "selections": [
          {
            "alias": null,
            "args": (v6/*: any*/),
            "concreteType": "OfferConnection",
            "kind": "LinkedField",
            "name": "deals",
            "plural": false,
            "selections": (v19/*: any*/),
            "storageKey": null
          },
          {
            "alias": "dealPromos",
            "args": (v16/*: any*/),
            "concreteType": "OfferConnection",
            "kind": "LinkedField",
            "name": "deals",
            "plural": false,
            "selections": (v20/*: any*/),
            "storageKey": null
          }
        ]
      }
    ]
  },
  "params": {
    "cacheID": "8f0ea9ca747beaab7807526b7b29deed",
    "id": null,
    "metadata": {},
    "name": "useOffersQuery",
    "operationKind": "query",
    "text": "query useOffersQuery(\n  $requiredTags: [String!]\n  $rejectedTags: [String!]\n  $promoTags: [String!]\n  $promoRejectedTags: [String!]\n  $fetchCashbacks: Boolean!\n  $fetchDeals: Boolean!\n) {\n  cashbacks(input: {requiredTags: $requiredTags, rejectedTags: $rejectedTags}) @include(if: $fetchCashbacks) {\n    edges {\n      node {\n        id\n        guid\n        title\n        description\n        rewardLabel\n        paysReward\n        advertiser {\n          name\n          imageUrl\n        }\n        categories {\n          tag\n          name\n        }\n        tags\n      }\n    }\n    id\n  }\n  cashbackPromos: cashbacks(input: {requiredTags: $promoTags, rejectedTags: $promoRejectedTags}) @include(if: $fetchCashbacks) {\n    edges {\n      node {\n        id\n        guid\n        imageUrl\n        desktopImageUrl\n        title\n        rewardLabel\n        advertiser {\n          name\n        }\n        tags\n      }\n    }\n    id\n  }\n  deals(input: {requiredTags: $requiredTags, rejectedTags: $rejectedTags}) @include(if: $fetchDeals) {\n    edges {\n      node {\n        id\n        guid\n        title\n        description\n        rewardLabel\n        paysReward\n        advertiser {\n          name\n          imageUrl\n        }\n        categories {\n          tag\n          name\n        }\n        tags\n      }\n    }\n    id\n  }\n  dealPromos: deals(input: {requiredTags: $promoTags, rejectedTags: $promoRejectedTags}) @include(if: $fetchDeals) {\n    edges {\n      node {\n        id\n        guid\n        imageUrl\n        desktopImageUrl\n        title\n        rewardLabel\n        advertiser {\n          name\n        }\n        tags\n      }\n    }\n    id\n  }\n}\n"
  }
};
})();

(node as any).hash = "22dd6f7390ca57d6202f56a6d75f35cf";

export default node;
